let ctx: AudioContext | undefined;

function getCtx() {
  if (!ctx) ctx = new AudioContext();
  return ctx;
}

export function tone(freq = 440, duration = 0.05, gain = 0.035) {
  try {
    const audio = getCtx();
    const osc = audio.createOscillator();
    const amp = audio.createGain();
    osc.frequency.value = freq;
    osc.type = 'sine';
    amp.gain.value = gain;
    osc.connect(amp).connect(audio.destination);
    osc.start();
    amp.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + duration);
    osc.stop(audio.currentTime + duration + 0.02);
  } catch {
    // Audio is strictly cosmetic; ignore autoplay/device errors.
  }
}
